"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessMenuGroupType = exports.MenuGroupType = void 0;
var MenuGroupType;
(function (MenuGroupType) {
    MenuGroupType[MenuGroupType["PROCESS"] = 1] = "PROCESS";
    MenuGroupType[MenuGroupType["PIPELINE"] = 2] = "PIPELINE";
    MenuGroupType[MenuGroupType["AI_MODEL"] = 3] = "AI_MODEL";
    MenuGroupType[MenuGroupType["MODEL_SKILL"] = 4] = "MODEL_SKILL";
})(MenuGroupType || (exports.MenuGroupType = MenuGroupType = {}));
var ProcessMenuGroupType;
(function (ProcessMenuGroupType) {
    ProcessMenuGroupType[ProcessMenuGroupType["Process"] = 1] = "Process";
    ProcessMenuGroupType[ProcessMenuGroupType["AIModel"] = 2] = "AIModel";
    ProcessMenuGroupType[ProcessMenuGroupType["ModelSkill"] = 3] = "ModelSkill";
})(ProcessMenuGroupType || (exports.ProcessMenuGroupType = ProcessMenuGroupType = {}));
